'use client'
import Loader from "atoms/Loader"

export default function Loading() {
  return <Loader type="fullPage" />
}